// pages/Testimonials.js — mobile responsive

import React, { useEffect } from 'react';
import CtaBand from '../components/CtaBand';

const testimonials = [
  { text: `"From the first conversation to the final install, the whole experience was a breath of fresh air. Jamie runs the business with a level of care you don't see very often anymore — thoughtful advice, zero pressure, and real attention to what we actually wanted to use the kitchen for day to day. Everything was handled smoothly, timelines were clear, and any questions we had were answered straight away. We honestly love spending time in our kitchen now, which says everything. Couldn't recommend Jamie and the team more highly."`, name: 'Jonathan Rea', location: 'Belfast' },
  { text: `"We're absolutely delighted with our new kitchen. From the very start, Jamie took the time to understand what we wanted and offered honest, practical suggestions that really improved the final design. Nothing felt rushed and the attention to detail throughout the process was excellent. The installation team were professional, tidy and transformed how we use our home. It's rare to find a business that combines great craftsmanship with such genuine customer care. Highly recommended."`, name: 'Ibe Sesay', location: 'Lisburn' },
];

const stats = [
  { num: '200+', label: 'Projects Completed' },
  { num: '99%',  label: 'Client Satisfaction' },
  { num: '25+',  label: 'Years Experience' },
  { num: '5★',   label: 'Average Rating' },
];

export default function Testimonials() {
  useEffect(() => { window.scrollTo({ top: 0 }); }, []);

  return (
    <div className="page-wrapper--inner">
      <div style={{ height: "60px" }} />
      <style>{`
        .test-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1.5rem;
          margin-bottom: 5rem;
        }
        .stats-bar {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          border: 1px solid var(--border);
        }
        @media (max-width: 768px) {
          .test-grid { grid-template-columns: 1fr; }
          .stats-bar { grid-template-columns: 1fr 1fr; }
        }
        @media (max-width: 400px) {
          .stats-bar { grid-template-columns: 1fr 1fr; }
        }
      `}</style>

      <section className="section">
        <div className="container">
          <div className="label">Client Stories</div>
          <h2 className="heading-xl">What Our<br /><span className="orange-italic">Clients Say</span></h2>
          <br />
          <p className="subtext" style={{ maxWidth: 560, marginBottom: '4rem' }}>
            Don't just take our word for it. Hear from the homeowners who have trusted us to transform their kitchens.
          </p>

          <div className="test-grid">
            {testimonials.map((t, i) => (
              <div key={i} style={s.card}>
                <div style={s.quote}>❝❞</div>
                <p style={s.text}>{t.text}</p>
                <div style={s.stars}>★★★★★</div>
                <div style={s.name}>{t.name}</div>
                <div style={s.loc}>{t.location}</div>
              </div>
            ))}
          </div>

          <div className="stats-bar">
            {stats.map((stat, i) => (
              <div key={i} style={{ ...s.statsCell, borderRight: i < stats.length - 1 ? '1px solid var(--border)' : 'none' }}>
                <div style={s.statsNum}>{stat.num}</div>
                <div style={s.statsLabel}>{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBand
        title="Join Our Satisfied Clients"
        text="Ready to experience the Urban Kitchens difference? Let's start your journey."
        buttons={[{ label: 'Book a Consultation', to: '/contact' }]}
      />
    </div>
  );
}

const s = {
  card: { background: 'var(--bg3)', border: '1px solid var(--border)', padding: '2.5rem' },
  quote: { fontSize: '2.5rem', color: 'rgba(232,130,26,0.3)', fontFamily: 'serif', lineHeight: 1, marginBottom: '1.5rem' },
  text: { color: 'var(--text-muted)', fontSize: '0.88rem', lineHeight: 1.9, marginBottom: '2rem', fontStyle: 'normal' },
  stars: { color: 'var(--orange)', fontSize: '0.9rem', marginBottom: '0.75rem' },
  name: { fontFamily: "'Cormorant Garamond', serif", fontSize: '1.1rem', fontWeight: 500 },
  loc: { fontSize: '0.78rem', color: 'var(--text-muted)' },
  statsCell: { padding: '2.5rem 1rem', textAlign: 'center' },
  statsNum: { fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(2rem,4vw,3rem)', color: 'var(--orange)', lineHeight: 1, marginBottom: '0.5rem' },
  statsLabel: { fontSize: '0.65rem', fontWeight: 500, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--text-muted)' },
};
